
const LOGIN_API = {
    login:{
        method: 'post',
        url: 'sr_scm/login'
    },
    getVerifyCode:{
        method: 'get',
        url: 'sr_scm/createVerifyCode'
    }
}

export default LOGIN_API